//const zxcvbn = require('zxcvbn');

const isNumericByReg = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  let regexp = new RegExp('^([1-9]+[0-9]*|0)$');
  return regexp.test(value);
}

const checkPasswordStrength = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  const result = passwordRole(value);
  return result;
}

function passwordRole(password){
  if(password.length<10){
    return false;
  }
        
  if (password.match(/^[a-zA-Z0-9]+$/)) {
    return false;
  }
    
  if(!password.match(/[a-z]/)) {
    return false;
  }
    
  if(!password.match(/[A-Z]/)) {
    return false;
  }
  if(!password.match(/[0-9]/)) {
    return false;
  }
  return true;
}
export  {
  isNumericByReg,
  checkPasswordStrength
}